import { SendInfoResponseType } from '@/apis/api/addressApis';
import { atom } from 'recoil';

// 이벤트모달 표출하는 RECOIL
export const openModalRecoil = atom<boolean>({
  key: 'openModalRecoil',
  default: false,
});

export const toggleSaveModalRecoil = atom<boolean>({
  key: 'toggleSaveModalRecoil',
  default: false,
});

export const unknownReceiverRecoil = atom<string[]>({
  key: 'unknownReceiverRecoil',
  default: [],
});

// 정기결제 받는 모달 표출하는 RECOIL
export const amountModalRecoil = atom<boolean>({
  key: 'amountModalRecoil',
  default: false,
});

export const OpenModalDataRecoil = atom<SendInfoResponseType>({
  key: 'OpenModalDataRecoil',
  default: undefined,
});

export const OpenModalCallNumRecoil = atom<'010' | '015' | ''>({
  key: 'OpenModalCallNumRecoil',
  default: '',
});

// 이벤트 모달 닫고 전송 표출하는 RECOIL
export const openInfoModalRecoil = atom<boolean>({
  key: 'openInfoModalRecoil',
  default: false,
});
